import React, { useState, useRef } from "react";
import AboutBannerImage1 from "../../src/assets/images/aboutbanner1.png";
import AboutBannerImage2 from "../../src/assets/images/aboutbanner2.jpeg";
import AboutBannerImage3 from "../../src/assets/images/dna1.png";
import CustomLine from "./CustomLine";
import AboutImage1 from "../../src/assets/images/image_40.png";
import AboutImage2 from "../../src/assets/images/image_41.png";
import AppoinmentModal from "./AppoinmnetModal";
import { FaMedal } from 'react-icons/fa';

const CoursesBanner = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const stickyButtonRef = useRef(null);


    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };


    return (
        <div className="custom-science">
            <div className="custom-padding bg-[#f4f6f2] xl-screen-padding flex gap-10 flex-col md:flex-row w-full min-h-screen bg-white">
                <div className="w-full md:w-1/2 flex flex-col justify-center aboutmain">
                    <p className="custom-padding-bottom text-[#7C517E] text-md sm:text-md font-lato block sm:flex items-center slide-left">
                        {/* <CustomLine /> */}
                        <span className="ml-0 sm:ml-2 text-p"></span>
                    </p>
                    <h2 className="custom-padding-bottom text-lg sm:text-xl custom-line-height md:text-xl lg:text-4xl font-semibold text-black leading-tight client-text">
                        Learn, Practice,
                        <br />
    <span className="text-[#6BCB3D]">Lead</span>
                    </h2>
                    {/* <p className="border-t-2 border-[#8f762c] mb-6"></p> */}
                    {/* <p className="mb-6 text-[#656565] text-p">
                        Nourish your body, the personalized way
                    </p> */}
                    <p className="text-[#939a9e] mb-6 text-p">
                        An advanced digital learning ecosystem designed for individuals who aspire to build meaningful, future-ready careers in clinical nutrition and evidence-based practice. 
                        </p>
                    <div className="flex flex-row gap-4 items-center mt-6 flex-wrap">

                        <a href="https://wa.me/+919557439399" target="_blank" rel="noopener noreferrer">
                            <button className="bg-[#6BCB3D] hover:bg-[#5bb532] text-white font-semibold px-6 py-2 sm:px-8 sm:py-3 rounded-xl transition-all duration-300">
                                Explore Courses
                            </button>
                        </a>

                        <button
                            className="bg-[#7C517E] hover:bg-[#6a456c] text-white font-semibold px-6 py-2 sm:px-8 sm:py-3 rounded-xl transition-all duration-300"
                            onClick={openModal}
                        >
                            Join the Academy
                        </button>

                        <AppoinmentModal isOpen={isModalOpen} onClose={closeModal} />
                    </div>
                    <div className="flex items-center gap-3 mt-4">
                        <div className="flex -space-x-2">
                            <div className="w-8 h-8 bg-gray-300 rounded-full border-2 border-white"></div>
                            <div className="w-8 h-8 bg-gray-400 rounded-full border-2 border-white"></div>
                            <div className="w-8 h-8 bg-gray-500 rounded-full border-2 border-white"></div>
                        </div>
                        <div>
                            <p className="text-sm font-semibold text-gray-700">
                                Trusted by 10,000+ Learners
                            </p>
                            <p className="text-xs text-gray-500">
                                Join our global community
                            </p>
                        </div>
                    </div>
                </div>

                <div className="w-full md:w-1/2 flex flex-col items-center justify-center">
                    <div className="relative rounded-lg overflow-hidden w-full max-w-md mx-auto mb-4">

                    </div>

                    <div className="relative rounded-lg overflow-hidden w-full max-w-md mx-auto">
                        <div className="aspect-w-1 aspect-h-1">
                            <img
                                src={AboutBannerImage2}
                                alt="Personalized roadmap"
                                className="w-full h-full object-cover"
                            />
                        </div>
                        <div className="absolute bottom-0  bg-white rounded-md  px-4 py-3 flex items-center gap-3 font-lato">

                            <div className="w-8 h-8 flex items-center justify-center ">
                                <FaMedal className="w-5 h-5 text-green-600" />
                            </div>

                            <div>
                                <p className="text-sm font-bold text-gray-800">
                                    #1 Rated
                                </p>
                                <p className="text-xs text-gray-500">
                                    Nutrition Academy
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <button
                    ref={stickyButtonRef}
                    type="button"
                    className="sticky-button bg-[#7c517e] text-white text-sm px-3 py-1 md:px-4 md:py-2 mt-2 md:mt-0 w-full cursor-pointer md:w-auto"
                    onClick={openModal}
                >
                    BOOK APPOINTMENT
                </button>

                <AppoinmentModal isOpen={isModalOpen} onClose={closeModal} />
            </div>

            <div className="bg-[#1f2d3d] py-10 px-6 ">
                <div className=" grid grid-cols-2 md:grid-cols-4 gap-6 text-center ">
                    <div>
                        <h2 className="text-[#6BCB3D] text-2xl md:text-3xl font-bold custom-padding-bottom text-lg sm:text-xl  font-semibold leading-tight client-text">50+</h2>
                        <p className="text-gray-300 text-xs md:text-sm mt-2 tracking-wide uppercase font-bold">
                            Expert-led Courses
                        </p>
                    </div>
                    <div>
                        <h2 className="text-[#6BCB3D] text-2xl md:text-3xl font-bold custom-padding-bottom text-lg sm:text-xl  font-semibold leading-tight client-text">25+</h2>
                        <p className="text-gray-300 text-xs md:text-sm mt-2 tracking-wide uppercase font-bold">
                            Certified Instructors
                        </p>
                    </div>
                    <div>
                        <h2 className="text-[#6BCB3D] text-2xl md:text-3xl font-bold custom-padding-bottom text-lg sm:text-xl  font-semibold leading-tight client-text">100%</h2>
                        <p className="text-gray-300 text-xs md:text-sm mt-2 tracking-wide uppercase font-bold">
                            Online & Self-Paced
                        </p>
                    </div>
                    <div>
                        <h2 className="text-[#6BCB3D] text-2xl md:text-3xl font-bold custom-padding-bottom text-lg sm:text-xl  font-semibold leading-tight client-text">15k+</h2>
                        <p className="text-gray-300 text-xs md:text-sm mt-2 tracking-wide uppercase font-bold">
                            Certificates Issued
                        </p>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default CoursesBanner;
